import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const RedirectHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;
    
    // Remove trailing slashes except for root
    if (currentPath !== '/' && currentPath.endsWith('/')) {
      const newPath = currentPath.slice(0, -1);
      navigate(newPath, { replace: true });
    }
    
    // Handle common redirect patterns
    const redirects = {
      '/home': '/',
      '/services': '/service-section',
      '/about-us': '/about',
      '/contact': '/contact-us'
    };
    
    if (redirects[currentPath]) {
      navigate(redirects[currentPath], { replace: true });
    }
  }, [location.pathname, navigate]);

  return null;
};

export default RedirectHandler;